import { createAction, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IHowTo } from "InterfacesTypes/interfaces";

export interface IHowTosState {
    howTos: IHowTo[];
    loading: boolean;
    error: string | null;
};

const initialState: IHowTosState = {
    howTos: [],
    loading: false,
    error: null,
};

export const fetchHowTos = createAction(
    "howTo/fetchHowTos"
);

export const howTosSlice = createSlice({
    name: "howTo",
    initialState,
    reducers: {
        fetchStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchSuccess(state, action: PayloadAction<IHowTo[]>) {
            state.loading = true;
            state.howTos = action.payload;
        },
        fetchFailure(state, action: PayloadAction<string | null | undefined>) {
            state.loading = false;
            state.error = action.payload ?? "Något gick fel vid howTo sagan.";
        },
        setHowTos(
            state,
            action: PayloadAction<IHowTo[]>
        ) {
            state.howTos = action.payload;
        },
    },
});

export const {
    fetchStart,
    fetchSuccess,
    fetchFailure,
    setHowTos,
} = howTosSlice.actions;

export const HowTosReducer = howTosSlice.reducer;